import { createAction } from 'app-components/flux/core/actionHelpers';

export const addUndo = createAction('ADD_UNDO');
export const undo = createAction('UNDO');
export const deleteUndo = createAction('DELETE_UNDO');
export const clearUndoStack = createAction('CLEAR_UNDO_STACK');
